// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_m-8","cls2":"FeedbackModal-cls2_IBz FeedbackModal-cls1_m-8"};